const ExportIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className="h-full w-full"
      height="100%"
      viewBox="0 0 28 20.324"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_5574"
            data-name="Rectangle 5574"
            width={'100%'}
            height={'100%'}
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Group_9519" data-name="Group 9519" transform="translate(0 0)">
        <g
          id="Group_9518"
          data-name="Group 9518"
          transform="translate(0 0)"
          opacity="0.3"
          clipPath="url(#clip-path)"
          style={{ mixBlendMode: 'normal', isolation: 'isolate' }}
        >
          <path
            id="Path_12217"
            data-name="Path 12217"
            d="M27.832,9.558,17.915.126a.469.469,0,0,0-.776.408V4.845a.5.5,0,0,1-.429.53C13.5,5.648,4.257,7.565.041,18.632c-.189.494.321.956.708.644,2.287-1.842,7.51-5.02,15.933-4.55a.521.521,0,0,1,.457.539v4.526a.468.468,0,0,0,.783.4l9.917-9.825a.58.58,0,0,0-.007-.808"
            transform="translate(0 0)"
          />
        </g>
      </g>
    </svg>
  )
}

export default ExportIcon
